import LinearDelivery from "./LinearDelivery";

export default LinearDelivery;
